export default __webpack_public_path__ + "static/cardBg2-5a401d4629a0e25af42c36ade564719f.png";